"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useToast } from "modules/common/components/toast/useToast";

/**
 * Client component that displays error messages when users are redirected
 * from city pages with invalid or missing coordinates
 */
export function MapErrorHandler() {
  const searchParams = useSearchParams();
  const toast = useToast();
  const error = searchParams?.get("error");
  useEffect(() => {
    if (error === "city-not-found") {
      toast.error("City not found. Please try a different location.", {
        duration: 5000,
      });
    } else if (error === "missing-coordinates") {
      toast.error(
        "City coordinates are required. Please search for a city to view trades.",
        { duration: 5000 }
      );
    } else if (error === "invalid-coordinates") {
      toast.error(
        "Invalid city coordinates provided. Please search for a valid city.",
        { duration: 5000 }
      );
    }
  }, [error, searchParams, toast]);

  return null;
}
